<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="closeModal()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        {{ widgetModal.widget ? 'Edit' : 'Create' }} Reviews Widget
      </h3>

      <div :class="'section_wrap '+(settings == 'widget' ? 'open' : '')">
        <div
          class="section_head"
          @click="(settings == 'widget' ? settings = '' : settings = 'widget')"
        >
          <h3 class="section_heading">
            Widget Settings
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings == 'widget'"
            class="section_body"
          >
            <custom-input
              v-model="widget.name"
              label="Widget name"
              placeholder="Enter a name for the widget (optional)"
              width="full"
            />

            <custom-select
              v-model="widget.attributes.options.location"
              :options="gmbLocations"
              label="Location"
              width="third"
            />

            <custom-select
              v-if="widget.attributes.type.includes('table')"
              v-model="widget.attributes.options.metric"
              :options="{
                all: 'All Reviews',
                positive: 'Positive Reviews',
                negative: 'Negative Reviews',
                no_response: 'No Response'
              }"
              label="Metric"
              width="third"
            />

            <custom-input
              v-model="widget.attributes.options.limit"
              label="Limit results to"
              placeholder="All results"
              type="number"
              width="third"
            />

            <custom-select
              v-model="widget.attributes.options.useDatesFrom"
              :options="{
                all_dates: 'All dates',
                report: 'Report date range',
                custom: 'Custom date range',
              }"
              label="Use date range"
              width="half"
            />

            <custom-select
              v-model="widget.attributes.options.filterDateField"
              :options="{
                created_at: 'Created At',
                review_date: 'Review Date',
                review_reply_at: 'Review Replied At'
              }"
              label="Filter based on"
              width="half"
            />

            <div
              v-if="widget.attributes.options.useDatesFrom == 'custom'"
              class="custom_daterange"
            >
              <custom-input
                :disabled="true"
                :placeholder="selectedDateRange(widget.attributes.options.dates.fromDate, widget.attributes.options.dates.toDate)"
                label="Date range"
                width="half"
              />

              <button
                class="btn secondary_btn open-datepicker half"
                @click="datepicker = true"
              >
                <span>Select Date Range</span>
              </button>

              <date-range-picker
                v-if="datepicker"
                v-model:compFromDate="widget.attributes.options.dates.compFromDate"
                v-model:compRange="widget.attributes.options.dates.compRange"
                v-model:compToDate="widget.attributes.options.dates.compToDate"
                v-model:dateRange="widget.attributes.options.dates.dateRange"
                v-model:fromDate="widget.attributes.options.dates.fromDate"
                v-model:toDate="widget.attributes.options.dates.toDate"
                :allow-compare="false"
                @change="dates => setWidgetDates(dates)"
                @close="datepicker = false"
              />
            </div>

            <custom-select
              v-model="widget.attributes.options.sortBy"
              :options="{
                comment: 'Review',
                review_date: 'Date Reviewed',
                review_reply: 'Review Reply',
                reviewer_name: 'Reviewer',
                sentiment_text: 'Sentiment',
                star_rating: 'Star Rating'
              }"
              label="Sort by"
              width="half"
            />

            <custom-select
              v-model="widget.attributes.options.sortDirection"
              :options="{
                desc: 'Descending',
                asc: 'Ascending',
              }"
              label="Sort direction"
              width="half"
            />

            <custom-multiselect
              v-model="widget.attributes.options.filterStars"
              :options="{
                5: '5 Stars',
                4: '4 Stars',
                3: '3 Stars',
                2: '2 Stars',
                1: '1 Stars',
              }"
              :placeholder="'No filter'"
              label="Filter by Stars"
              mode="tags"
              width="full"
            />

            <custom-multiselect
              v-if="widget.attributes.type.includes('table')"
              v-model="widget.attributes.options.visibleColumns"
              :options="{
                comment: 'Review',
                review_date: 'Date Reviewed',
                review_reply: 'Review Reply',
                reviewer_name: 'Reviewer',
                sentiment_text: 'Sentiment',
                star_rating: 'Star Rating'
              }"
              label="Visible Columns"
              mode="tags"
              width="full"
            />
          </div>
        </accordion-transition>
      </div>

      <div
        v-if="widget.attributes.type == 'table'"
        :class="'section_wrap '+(settings == 'table' ? 'open' : '')"
      >
        <div
          class="section_head"
          @click="(settings == 'table' ? settings = '' : settings = 'table')"
        >
          <h3 class="section_heading">
            Table Settings <small>(optional)</small>
          </h3>
          <i class="icon arrow_down_icon caret" />
        </div>
        <accordion-transition>
          <div
            v-if="settings == 'table'"
            class="section_body"
          >
            <custom-select
              v-model="widget.attributes.tableOptions.align"
              :options="{
                'center' : 'Center',
                'start' : 'Left',
                'end' : 'Right'
              }"
              label="Text Align"
              width="full"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerColor"
              label="Header color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.headerTextColor"
              label="Header text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowColor"
              label="Primary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.primaryRowTextColor"
              label="Primary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowColor"
              label="Secondary row color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />

            <custom-color-select
              v-model="widget.attributes.tableOptions.secondaryRowTextColor"
              label="Secondary row text color"
              placeholder="Enter a hex value E.g. #ffffff"
              width="half"
            />
          </div>
        </accordion-transition>
      </div>

      <div class="flex items-center section_modal_footer">
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="closeModal()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>{{ widgetModal.widget ? 'Update' : 'Create' }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import moment from 'moment';
import _ from 'lodash';

import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomColorSelect from '../../global/forms/CustomColorSelect.vue';
import CustomMultiselect from '../../global/forms/CustomMultiselect.vue';
import DateRangePicker from '../../global/forms/DateRangePicker.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';

export default {
  components: {
    CustomInput,
    CustomSelect,
    CustomColorSelect,
    CustomMultiselect,
    DateRangePicker,
    AccordionTransition
  },
  emits: ['refresh-widget'],
  data() {
    return {
      datepicker: false,
      settings: 'widget',
      widgetTypes: {
        'line-chart': 'Line chart',
        'area-chart': 'Area chart'
      },
      widget: {
        id: `widget-reviews-${Date.now()}`,
        name: 'Reviews Widget',
        type: 'reviews',
        w: 12,
        h: 25,
        frozen: false,
        content: `<div id="widget-reviews-${Date.now()}"><div class="widget-loading"><i class="fa fa-btn fa-spinner fa-spin"></i></div></div>`,
        attributes: {
          type: 'table',
          options: {
            location: null,
            metric: 'all',
            limit: null,
            sortBy: 'review_date',
            sortDirection: 'desc',
            useDatesFrom: 'report',
            filterDateField: 'created_at',
            dates: {
              dateRange: null,
              compRange: null,
              fromDate: '',
              toDate: '',
              compFromDate: '',
              compToDate: ''
            },
            filterStars: [],
            visibleColumns: ['comment', 'review_date', 'review_reply', 'reviewer_name', 'sentiment_text', 'star_rating']
          },
          tableOptions: {
            align: 'center',
            headerColor: '#F5F5F5',
            headerTextColor: '#4E4E54',
            primaryRowColor: '#FFFFFF',
            primaryRowTextColor: '#4E4E54',
            secondaryRowColor: '#F8F7F5',
            secondaryRowTextColor: '#4E4E54',
          },
        }
      }
    }
  },
  computed: {
    ...mapState(['widgetModal']),
    ...mapState('lookups', ['gmbLocations']),
    ...mapState('report', ['report'])
  },
  beforeMount() {
    if (this.widgetModal.widget) {
      _.merge(this.widget, this.widgetModal.widget);
      this.widget.attributes.options.visibleColumns = this.widgetModal.widget.attributes.options.visibleColumns;
    }
    if (!this.widgetModal.widget) this.widget.attributes.options.location = Object.keys(this.gmbLocations).length > 0 ? Object.keys(this.gmbLocations)[0] : null;
  },
  methods: {
    ...mapActions('pages', ['addWidget', 'updateWidget']),
    ...mapActions('widgetModal', ['closeModal']),
    selectedDateRange(fromDate, toDate) {
      if (fromDate && toDate) {
        let from = moment(fromDate, 'YYYY-MM-DD').format(this.report.date_format);
        let to = moment(toDate, 'YYYY-MM-DD').format(this.report.date_format);
        return from + ' - ' + to;
      }
      return 'Please select dates';
    },
    async save() {
      if (!this.widget.resized && !this.widgetModal.widget) {
        if (this.widget.attributes.type.includes('table') || this.widget.attributes.type.includes('stat-boxes')) this.widget.w = 12;
      }

      // Prep a payload for the vuex action
      const payload = {
        widget: this.widget,
        pageId: this.widgetModal.pageId,
      }

      // Check if we're creating a new widget or editing one
      if (!this.widgetModal.widget) {
        // Save the new pages layout (refreshes store pages)
        await this.addWidget(payload);
      } else {
        // Update the widget
        payload.widget.resized = false;
        await this.updateWidget(payload);
      }

      // Emit to trigger widget refresh, then close the modal
      this.$emit('refresh-widget', {pageId: this.widgetModal.pageId, widget: this.widget});
      this.closeModal();
    }
  }
}
</script>

<style scoped src="../../../../reports/css/modal.css" />
